import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)

const DateControl = ({ field='',label, type = 'text',id, placeholder='', value='', onChange=()=>'',readOnly=false,minDate=null,maxDate=null}) => {
    return (
        <div className="sg-input mt-15">
            <label htmlFor={id}>{label}</label>
            <DatePicker className="date-vsp" locale="es" selected={value} onChange={onChange} dateFormat='dd/MM/yyyy' readOnly={readOnly} minDate={minDate} maxDate={maxDate}/>           
        </div>
    );
}

export default DateControl;
